import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError, finalize } from 'rxjs';
import { EventService } from 'src/app/services/event-services/error-event.service';

let message;
@Injectable()

export class ErrorCatchingInterceptor implements HttpInterceptor {
    constructor ( public errorEvent: EventService, ) {
    }
    intercept ( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
         if (req.headers.has('skip_token_interceptor')) {
        // skip token header and pass the request to the next handler (For proctoring api)
        return next.handle(req);
      }
        return next.handle(req).pipe(
            catchError((error) => {
                this.handleError(error);
                this.errorEvent.httpErrorMessageEvent.emit(message);
                return throwError(() => error);
            })
        );
    }

    private handleError ( err: HttpErrorResponse ) {
        let id = '#' + new Date().getMilliseconds();
        sessionStorage.setItem( 'errorId', id );
        if ( err.status === 0 ) {
            console.error( 'An error occurred:', err.error );
            message = "Service Unreachable" + id;
        } else if ( err.status === 401 ) {

            message = "UnAuthorized/Token Expired" + id;
            window.location.assign( "/login" );
        } else {

            console.error( "Backend error: " + err.status, err.error );
            message = ( err.error.message == ( undefined || null ) ?
                ( err.error.title == ( undefined || null ) ? err.error : err.error.title )
                : err.error.message ) + id;
        }
        return throwError( () => new Error( message ) );
    }
}